import 'jquery';
import Vue from 'vue';
import Component from 'vue-class-component';
import ABaseComponent from "Components/Base/ABaseComponent";
import { PorterKey, MovePorterCommandArguments, PorterListViewModel, IPorterBudget, IPorterViewModel, MutationLocation, GenericFieldDescription, UpdatePorterCommandArguments } from 'Api/CoreApi';
import porterBuilder from 'Store/porterbuilder/porterbuilder';
import { Prop, Watch } from "vue-property-decorator";
import ApiProvider from 'Api/ApiProvider';
import 'select2';
import PorterListValidation from '../PorterValidation/PorterListValidation';
import * as XLSX from 'xlsx';
import { forEach } from 'lodash-es';
import Axios from 'axios';

export interface MutationViewModel {
    code: string;
    description: string;
    locations: LocationViewModel[];
}

export interface LocationViewModel {
    code: string;
    description: string;
    porters: IPorterViewModel[];
}

@Component({ validations: PorterListValidation })
export default class PorterListComponent extends ABaseComponent {
    public search: string = '';
    public locationSearch: string = '';
    public updatePorterMode: string = '';
    public newCustomerNumber: string = '';
    public newFunctionCode: string = '';
    public updatePorter: IPorterViewModel = null;
    public orginalPorter: IPorterViewModel = null;
    public mutationLocations: MutationLocation[] = [];
    public mutationFunctionCodes: string[] = [];
    public hasBudget: boolean = false;
    public porterViewModelFields: GenericFieldDescription[] = [];
    @Prop()
    public invalidMailMessage: string;

    @Prop()
    public customerUsesFunctions: boolean;

    @Prop()
    public initialMail: string;

    @Prop({ default: "EN" }) 
    public languageId: string; 

    @Prop()
    modalMessage: string;

    downloadEmail: string = '';

    public: string = "";
    model: PorterListViewModel | null = null;

    // Only show mutation header if there are more than 1 mutation
    public get showMutationHeader() {
        return this.mutations.length > 1;
    }

    // Only show location header if there are more than 1 location
    public get showLocationHeader() {

        return this.showMutationHeader
            || this.mutations.length == 1 && this.mutations[0].locations.length > 1;
    }

    porterBudgets: IPorterBudget[] = [];

    porterBudgetRemaining(porterUserName: string) {
        if (this.porterBudgets.length == 0 || !this.porterBudgets.some(x => x.porterNo == porterUserName)) {
            return "";
        }
        let porterBudget = this.porterBudgets.find(x => x.porterNo == porterUserName);
        
        if (porterBudget == null) {            
            return "";
        }

        if (porterBudget.typePoints == false && porterBudget.typeEuros == false) {
            return ""
        }

        return porterBudget;
    }

    async loadPorterBudgets() {
        const client = ApiProvider.getApiClient();
        var budgets = await client.getPorterBudgetsByCustomerNumber();
        if (budgets == null) {
            return;
        }
        this.porterBudgets = budgets.budgets;
    }

    created() {
        var self = this;
        this.downloadEmail = this.initialMail;

        $(document).on('afterClose.fb', function (e, instance, slide) {
            // resets form
            $(slide.src).find('form').trigger('reset');
            self.newCustomerNumber = '';
            self.porterViewModelFields = [];

            self.$v.$reset();
            $('.select2').val(null).trigger('change');
        });

        const client = ApiProvider.getApiClient();
        client.getPorterList()
            .then(async data => {
                this.model = data;

                data.porters.forEach(porter => {
                    if (porter.hasBudget) {
                        this.hasBudget = true;
                        return null;
                    }
                });

                await this.loadPorterBudgets();
                this.loading = false;
            })
            .catch(e => {
                this.error = e;
                this.loading = false;
            });
    }

    isMailValid() {
        //const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const re = /^(([a-zA-Z0-9_'+*$%\^&!\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9:]{2,20})([,;]\W?(?!$))?)+$/;
        var mail = this.downloadEmail;
        if (mail === '' || mail == null) {
            return false;
        }
        return re.test(String(mail).toLowerCase());
    }

    get getModalMessage():string {
        var value = this.modalMessage.replace("#EMAIL_PLACE_HOLDER#", this.downloadEmail);


        var isMailValid = this.isMailValid();
        if (!isMailValid) {
            value = this.invalidMailMessage.replace("#EMAIL_PLACE_HOLDER#", this.downloadEmail);
        }
        return value;
    }

    get locations(): { [code: string]: MutationLocation } {
        const locations: { [code: string]: MutationLocation } = {};
        for (const location of this.model.locations) {
            locations[location.customerNo] = location;
        }
        return locations;
    }

    get notSearching(): boolean {
        return (!this.search && !this.locationSearch);
    }

    get searchingForLocation(): boolean {
        return (!this.search && this.locationSearch.length > 0);
    }

    get searchingForLocationAndPorter(): boolean {
        return (this.search.length > 0 && this.locationSearch.length > 0);
    }

    get mutations(): MutationViewModel[] | null {
        const result: MutationViewModel[] = [];
        let currentMutation: MutationViewModel | null = null;
        let currentLocation: LocationViewModel | null = null;

        if (!this.model || !this.model.porters) {
            return null;
        }

        for (const porter of this.model.porters.filter(this.includePorter)) {
            const location = this.locations[porter.customerNumber];
            if (!location) {
                console.warn(`Could not find location with code ${porter.customerNumber}`);
                continue;
            }
            if (!currentMutation || (location.mutationCode || '') !== currentMutation.code) {
                currentMutation = {
                    code: location.mutationCode || '',
                    description: location.mutationDescription || location.mutationCode || '',
                    locations: []
                };
                result.push(currentMutation);
            }
            if (!currentLocation || currentLocation.code !== (location.customerNo || '')) {
                currentLocation = {
                    code: location.customerNo || '',
                    description: location.locationName || location.customerNo || '',
                    porters: []
                };
                currentMutation.locations.push(currentLocation);
            }
            currentLocation.porters.push(porter);

        }
        return result;
    }

    private getHiddenFields() {
        let genFields = Object.keys(this.updatePorter.genericFields);
        let newPorterFields = this.porterViewModelFields.map(gen => gen.key);
        return genFields.filter(gen => !newPorterFields.includes(gen));
    }

    public get hasGenericError() : boolean {
        if (this.updatePorter == null || this.updatePorter.genericFields == null) return false;
        let hiddenGenFields = this.getHiddenFields(); 
        return hiddenGenFields.some(gen => this.$v.updatePorter.genericFields[gen] && this.$v.updatePorter.genericFields[gen].$anyError);
    }

    public get errorFields(): string {
        if (this.updatePorter == null || this.updatePorter.genericFields == null) return "";
        let hiddenGenFields = this.getHiddenFields(); 
        return hiddenGenFields.filter(gen => this.$v.updatePorter.genericFields[gen].$anyError).map(field => this.model.fields.find(x => x.key === field).caption).join(",");
    }

    exportPorters(): void {
        const workbook = XLSX.utils.book_new();
        const data: string[][] = [];
        const columns: string[] = [];

        // First we build the headers columns (NOT my code!)
        columns.push(this.$i18n.t("Porter").toString());
        columns.push(this.$i18n.t("Customer No").toString());
        columns.push(this.$i18n.t("Name").toString());

        if (this.customerUsesFunctions) {
            columns.push(this.$i18n.t("Funcion Code").toString());
        }

        forEach(this.model.fields, (field) => {
            columns.push(this.$i18n.t(field.key).toString());
        });
        data.push(columns);

        // Next the data from each porter is written.
        forEach(this.mutations, (mutation) => {
            forEach(mutation.locations, (location) => {
                forEach(location.porters, (porter) => {
                    let porterData: string[] = [];
                    porterData.push(porter.lastName + " " + porter.firstName);

                    const cleanCustomerNumber = porter.customerNumber.split('-at-')[0];
                    porterData.push(cleanCustomerNumber);

                    porterData.push(location.description);

                    if (this.customerUsesFunctions) {
                        porterData.push(porter.functionCode);
                    }

                    forEach(this.model.fields, (field) => {
                        if (field.inputType == "boolean") {
                            porterData.push(this.$i18n.t(porter.genericFields[field.key]).toString());
                        } else {
                            porterData.push(porter.genericFields[field.key]);
                        }
                    });

                    data.push(porterData);
                });


            });
        });
        let worksheet = XLSX.utils.aoa_to_sheet(data);

        const sheetName = this.$i18n.t("Porterlist").toString(); //location.code.split('-at-')[0] + " " + location.description;
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
        XLSX.writeFile(workbook, "porterlist.xlsx");
    }

    private getPorterSearchableText(porter: IPorterViewModel): string {
        const customerNumberParts = porter.customerNumber.split("-", 1);

        const locationName = (typeof this.locations[porter.customerNumber] !== 'undefined')
            ? this.locations[porter.customerNumber].locationName.toLowerCase()
            : "";

        const customerNumber = (customerNumberParts.length > 0)
            ? customerNumberParts[0].toLowerCase()
            : "";

        return customerNumber + " " + locationName;
    }

    private includePorter(porter: IPorterViewModel) {
        if (this.notSearching) {
            return true;
        }

        const containsLocationOrCustomerName = (this.getPorterSearchableText(porter).indexOf(this.locationSearch.toLowerCase()) > -1);

        if (this.searchingForLocation) {
            return containsLocationOrCustomerName;
        }

        if (this.searchingForLocationAndPorter && !containsLocationOrCustomerName) {
            return false;
        }

        if (porter.firstName.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
            porter.lastName.toLowerCase().indexOf(this.search.toLowerCase()) > -1) {
            return true;
        }

        // Search in porter mandatory fields
        for (let key in porter.genericFields) {
            if (porter.genericFields[key].toLowerCase().indexOf(this.search.toLowerCase()) > -1) {
                return true;
            }
        }

        return false;
    }

    gotoLink(porterModel: IPorterViewModel, basePath: string) {
        location.href = basePath
            + (basePath.indexOf('?') > -1 ? '&' : '?')
            + 'porterId='
            + porterModel.id;
    }

    updateModal(porter: IPorterViewModel, updatePorterMode: string, mutationCode: string = '') {
        this.updatePorter = porter;
        this.updatePorterMode = updatePorterMode;
        this.orginalPorter = porter;

        // Dont show select box if modal is not in mutation mode
        $(".select2").hide();

        if (mutationCode.length > 0) {

            const client = ApiProvider.getApiClient();
            client.getLocationsByMutation(mutationCode).then(result => {
                this.mutationLocations = result;

                // Enable search in list
                const elem = document.getElementById("location-select");
                const target = $(elem);

                target.select2();

                target.change(() => {
                    const newCustomerNumber = $('.location-select').find("option:selected").val().toString();
                    this.newCustomerNumber = newCustomerNumber;
                    var oldData = this.orginalPorter.genericFields;

                    client.getPorterFieldListByCustomer(newCustomerNumber)
                        .then(data => {
                            const fields = data.fields;
                            this.porterViewModelFields = fields;

                            for (let i = 0; i < fields.length; i++) {
                                const field = fields[i];
                                Vue.set(this.updatePorter.genericFields, field.key, this.updatePorter.genericFields[field.key]);
                            }

                            // loop updatePorter.genericFields and if the key exist in oldData, then use the oldData value
                            for (let key in oldData) {          
                                if (this.updatePorter.genericFields.hasOwnProperty(key)) {
                                    this.updatePorter.genericFields[key] = oldData[key];
                                }
                            }

                            this.$v.$reset();
                        })
                        .catch(e => {
                            this.setError(e);
                        });
                });

                this.newCustomerNumber = target.find("option:first-child").val().toString();

                $(".select2").show();

            });

            client.getPorterFunction(porter.customerNumber).then(result => {
                if (result.functions.length > 0)
                    this.mutationFunctionCodes = result.functions;
                else
                    this.mutationFunctionCodes = null;
            });
        }
    }

    @Watch("newCustomerNumber")
    async onLocationChange() {
        const client = ApiProvider.getApiClient();
        client.getPorterFunction(this.newCustomerNumber).then(result => {
            if (result.functions.length > 0) {
                this.mutationFunctionCodes = [];
                this.mutationFunctionCodes = result.functions;
            }
            else
                this.mutationFunctionCodes = null;
        });
    }

    async updateUiDownloadState(elem : HTMLElement, state:ReportDownloadState) : Promise<void>{
        let att = elem.getAttribute("data-parent-button");
        let myButton = document.querySelector(`[data-button-for='${att}']`);
        myButton.classList.remove("loading");
        myButton.classList.remove("saved");
        myButton.classList.remove("error");
        let classToAddAndRemove = "";
        switch(state){
            case ReportDownloadState.Loading:
                classToAddAndRemove = "loading";
                break;
            case ReportDownloadState.Success:
                classToAddAndRemove = "saved";
                break;
            case ReportDownloadState.Failed:
                classToAddAndRemove = "error";
                break;
        }
        myButton.classList.add(classToAddAndRemove);
        await setTimeout(()=>{
            myButton.classList.remove(classToAddAndRemove);
        },2000);
    }
    
    async downloadBarcodes(contactNo:string, e : Event) {
        let element = <HTMLElement>e.target;

        if (!this.isMailValid()) {
            this.updateUiDownloadState(element, ReportDownloadState.Failed);

        }
        this.updateUiDownloadState(element, ReportDownloadState.Loading);

       try {
           let result =
               await Axios.get(
                   `/api/CustomerCenter/GetDocument?documentType=CustomerBarcodeList&email=${this.downloadEmail}&from=${this.lastYear.toISOString()
                   .substring(0, 10)}&to=${new Date().toISOString().substring(0, 10)}&porters=${contactNo}`);
        if(result.status==200){
            this.updateUiDownloadState(element, ReportDownloadState.Success);
        }
        
       }catch(e){
            console.log(e);
          
       }
        
    }

    async downloadArticleLists(contactNo:string,e : Event) {

        let element = <HTMLElement>e.target;

        if (!this.isMailValid()) {
            this.updateUiDownloadState(element, ReportDownloadState.Failed);

        }
        await this.updateUiDownloadState(element, ReportDownloadState.Loading);
       try{
           let response = await Axios.get(`/api/CustomerCenter/GetDocument?documentType=PorterArticleList&email=${this.downloadEmail}&from=${this.lastYear.toISOString().substring(0, 10)}&to=${new Date().toISOString().substring(0, 10)}&porters=${contactNo}`);
        if(response.status==200){
            this.updateUiDownloadState(element, ReportDownloadState.Success);
        }
        
       }catch(e){
            console.log(e);
          
       }
      
    }

    get lastYear() {
        let thisYear = new Date();
        thisYear.setFullYear(thisYear.getFullYear() - 1);
        return thisYear; 
    }

    retirePorter() {
        const client = ApiProvider.getApiClient();
        client.retirePorter(this.languageId,new PorterKey({
            id: this.updatePorter.id
        }))
        .catch(e => {
            this.setError(e);
        });

        // Reload porterlist
        client.getPorterList()
            .then(data => {
                this.model = data;
                this.setLoaded();
            })
            .catch(e => {
                this.setError(e);
            });
    }

    async mutatePorter() {
        this.setLoading();

        let porterToSave = this.updatePorter;
        const client = ApiProvider.getApiClient();

        this.$v.$touch();
        if (!this.$v.$invalid) {

            try {
                
                const movePorterCommandArguments = new MovePorterCommandArguments({
                    key: new PorterKey({ id: porterToSave.id }),
                    moveToCustomerNumber: this.newCustomerNumber,
                    firstName: porterToSave.firstName,
                    lastName: porterToSave.lastName,
                    genericFields: porterToSave.genericFields,
                    languageCode: this.languageId,
                    functionCode: (this.newFunctionCode == '') ? porterToSave.functionCode : this.newFunctionCode
                });

                await client.movePorter(movePorterCommandArguments);

            } catch (e) {
                this.setError(e);
            }

            // Reload porterlist
            client.getPorterList()
                .then(data => {
                    this.model = data;
                    this.setLoaded();
                })
                .catch(e => {
                    this.setError(e);
                });
            $.fancybox.close();
        }

        this.setLoaded();
    }

    gotoBuilder(porter: IPorterViewModel, url: string) {
        porterBuilder.dispatchSetPorterId(porter.id).then(() => window.location.href = url + "?porterNo=" + porter.contactNo);
    }
}
export enum ReportDownloadState{
    Loading,
    Success,
    Failed
}
Vue.component("porter-list", PorterListComponent);